import { memo } from 'react';
import { Button, Icon } from '@uniquegood/realworld-studio-design';

import { ToolbarStyle } from '../styles';

interface FlowToolbarProps {
  onAddMission: () => void;
  onAutoLayout: () => void;
  onSwitchToCardMode: () => void;
  showAllDependencies: boolean;
  onToggleDependencyVisibility: () => void;
}

function FlowToolbar({
  onAddMission,
  onAutoLayout,
  onSwitchToCardMode,
  showAllDependencies,
  onToggleDependencyVisibility
}: FlowToolbarProps) {
  return (
    <div css={ToolbarStyle}>
      <Button size="small" onClick={onAddMission}>
        <Icon icon="plus_solid" size="14px" /> 새 미션
      </Button>
      <Button size="small" type="outlineBasic" onClick={onAutoLayout}>
        자동 정렬
      </Button>
      <Button size="small" type="outlineBasic" onClick={onToggleDependencyVisibility}>
        {showAllDependencies ? '연결선: 전체' : '연결선: 선택'}
      </Button>
      <Button size="small" type="outlineBasic" onClick={onSwitchToCardMode}>
        카드 모드
      </Button>
    </div>
  );
}

export default memo(FlowToolbar);
